
export default {
  data() {
    return {
      styleResize: {
        height: '',
        width: ''
      }
    }
  },

  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler)
    this.$_resizeHandler()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  methods: {
    $_resizeHandler() {
      const width = document.documentElement.clientWidth
      const height = document.documentElement.clientHeight
      this.styleResize = {
        height: height,
        width: width
      }
    }
  }
}
